import React from 'react';
import clsx from 'clsx';

type LoadingSkeletonProps = {
  loading: boolean;
  className?: string;
  children: JSX.Element | null;
};

export function LoadingSkeleton({ loading, className = '', children }: LoadingSkeletonProps) {
  if (loading) {
    return <div className={clsx(className, 'animate-pulse rounded-md bg-neutral200')} />;
  }
  return children;
}
